import { z } from 'zod'
import { emailSchema } from './common'

// Authentication schemas
export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Password is required')
})

export const registerSchema = z.object({
  email: emailSchema,
  password: z.string().min(8, 'Password must be at least 8 characters'),
  name: z.string().min(2).max(255),
  role: z.enum(['HR_ADMIN', 'GENERAL_MANAGER', 'SYSTEM_ADMIN']),
  branchId: z.string().max(50).optional()
})

export const refreshTokenSchema = z.object({
  refreshToken: z.string().min(1, 'Refresh token is required')
})

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Current password is required'),
  newPassword: z.string().min(8, 'New password must be at least 8 characters'),
  confirmPassword: z.string().min(1, 'Password confirmation is required')
}).refine((data) => data.newPassword === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
})

export const resetPasswordSchema = z.object({
  email: emailSchema
})

export const resetPasswordConfirmSchema = z.object({
  token: z.string().min(1, 'Reset token is required'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
  confirmPassword: z.string().min(1, 'Password confirmation is required')
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"]
})

export const authResponseSchema = z.object({
  user: z.object({
    id: z.string().uuid(),
    email: emailSchema,
    name: z.string(),
    role: z.enum(['HR_ADMIN', 'GENERAL_MANAGER', 'SYSTEM_ADMIN']),
    branchId: z.string().nullable()
  }),
  token: z.string(),
  refreshToken: z.string()
})

// Type exports
export type LoginRequest = z.infer<typeof loginSchema>
export type RegisterRequest = z.infer<typeof registerSchema>
export type RefreshTokenRequest = z.infer<typeof refreshTokenSchema>
export type ChangePasswordRequest = z.infer<typeof changePasswordSchema>
export type ResetPasswordRequest = z.infer<typeof resetPasswordSchema>
export type ResetPasswordConfirmRequest = z.infer<typeof resetPasswordConfirmSchema>
export type AuthResponse = z.infer<typeof authResponseSchema> 